import { ComponentProps } from "react";
import { LayoutChangeEvent } from "react-native";
import { Box } from "../../ui/box";
import { Text } from "../../ui/text";

type MeasuredHiddenTextProps = {
  text: string;
  size?: ComponentProps<typeof Text>["size"];
  onMeasure: (event: LayoutChangeEvent) => void;
};

/**
 * Invisible `Text` that mirrors what an auto-width input displays, so its
 * layout width can drive the visible `InputField`'s width. Kept out of the
 * accessibility tree since it duplicates the real field's content.
 *
 * Only the padded wrapper reports its layout: its `px-3` matches the
 * `InputField`'s own horizontal padding, so the measured width already
 * includes the room the field needs around the text. Measuring the bare
 * `Text` as well made the last layout event win, and when that was the
 * unpadded one a long placeholder lost its final characters.
 */
export default function MeasuredHiddenText({
  text,
  size,
  onMeasure,
}: MeasuredHiddenTextProps) {
  return (
    <Box
      onLayout={onMeasure}
      className="px-3 absolute opacity-0 pointer-events-none"
    >
      <Text
        size={size}
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
      >
        {text}
      </Text>
    </Box>
  );
}
